"use strict";
exports.__esModule = true;
exports.chart_bullet_comparative_measure_stroke_Color = {
  "name": "--pf-chart-bullet--comparative-measure--stroke--Color",
  "value": "#4f5255",
  "var": "var(--pf-chart-bullet--comparative-measure--stroke--Color, #4f5255)"
};
exports["default"] = exports.chart_bullet_comparative_measure_stroke_Color;